<template>
  <div class="row d-none d-md-flex">
    <div class="col d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <router-link v-if="isRouteHome" :to="routeTo">
          <button class="btn back-button p-1 me-2 me-md-4">
            <i class="fa-solid fa-chevron-left custom-arrow"></i>
          </button>
        </router-link>
        <h3 class="header-text mb-0 me-md-3">{{ title }}</h3>
      </div>
      <div class="d-block d-md-none float-right">
        <button class="btn btn-primary" @click="showFilterDialog">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div v-if="isFilter" class="col-5 d-flex align-items-center">
      <select v-for="(item, idx) in filters" :key="idx" class="custom-select-choices"
        v-model="selected[item.selectLabel]" @change="filter(item.selectLabel)">
        <option v-for="option in item.selectOptions" :key="option.value" :value="option.value">
          {{ item.selectLabel }}:
          <span class="select-label">{{ option.text }}</span>
        </option>
      </select>
      <!-- <button class="btn btn-primary btn-sm" @click="reset">Reset</button> -->
    </div>
    <div v-if="isDateRange" class="col-4 p-1">
      <div class="row m-0">
        <div class="col d-flex">
          <label class="form-label mt-2 me-2" for="dateStart">Start:</label>
          <!-- <span class="custom-date">{{ formatDate(dateStart) }}</span> -->
          <input class="form-control" name="dateStart" type="date" v-model="dateStart" />
        </div>
        <div class="col d-flex">
          <label class="form-label mt-2 me-2" for="dateEnd">End:</label>
          <!-- <span class="custom-date">{{ formatDate(dateEnd) }}</span> -->
          <input class="form-control" name="dateEnd" type="date" v-model="dateEnd" :max="maxDate" />
        </div>
        <div class="col d-flex py-1 px-3">
          <button class="btn btn-primary btn-sm refreshButton" :disabled="isFetching" @click="refresh">
            <FontAwesomeIcon v-if="isFetching" icon="fa-solid fa-spinner" spin />
            <span class="ms-2">Refresh</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <DialogPreview :show="showFilters" modalSize="modal-xl">
    <template v-slot:header>
      <div class="row" style="width: 100%">
        <div class="col">
          <span class="custom-title">Filters</span>
          <span class="float-end" data-bs-dismiss="modal" @click="closeModal">
            <i class="fa fa-close" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </template>
    <template v-slot:body>
      <div v-if="isFilter" class="row d-flex align-items-center">
        <select v-for="(item, idx) in filters" :key="idx" class="custom-select-choices"
          v-model="selected[item.selectLabel]" @change="filter(item.selectLabel)">
          <option v-for="option in item.selectOptions" :key="option.value" :value="option.value">
            {{ item.selectLabel }}:
            <span class="select-label">{{ option.text }}</span>
          </option>
        </select>
        <!-- <button class="btn btn-primary btn-sm" @click="reset">Reset</button> -->
      </div>
      <div v-else class="col"></div>

      <div v-if="isDateRange" class="py-1">
        <div class="row">
          <div class="col-12 d-flex m-1">
            <label class="form-label mt-2 me-2" for="dateStart">Start:</label>
            <input class="form-control" name="dateStart" type="date" v-model="dateStart" />
          </div>
          <div class="col-12 d-flex m-1">
            <label class="form-label mt-2 me-2" for="dateEnd">End:</label>
            <input class="form-control" name="dateEnd" type="date" v-model="dateEnd" :max="maxDate" />
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <button type="button" class="btn btn-secondary px-4" data-bs-dismiss="modal" @click="closeModal">Close</button>
      <button type="button" class="btn btn-primary px-4 refreshButton" data-bs-dismiss="modal" :disabled="isFetching"
        @click="refresh">
        <FontAwesomeIcon v-if="isFetching" icon="fa-solid fa-spinner" spin />
        <span class="ms-2">Refresh</span>
      </button>
    </template>
  </DialogPreview>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { dashboardStore } from '@/stores/dashboard'
import DialogPreview from '@/components/utilities/elements/Dialog.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import moment from 'moment'
export default {
  name: 'ZFilterHeader',
  components: {
    DialogPreview,
    FontAwesomeIcon
  },
  props: {
    title: {
      type: String,
      default: null
    },
    isRouteHome: {
      type: Boolean,
      default: false
    },
    isDateRange: {
      type: Boolean,
      default: false
    },
    isFilter: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Array,
      default: () => {
        return []
      }
    },
    restriction: {
      type: Number,
      default: 1
    },
    routeTo: {
      type: String,
      default: '/'
    }
  },
  data() {
    return {
      maxDate: null,
      showFilters: null,
      selected: {
        Service: 'All',
        INS: 'All',
        Shop: 'All',
        Make: 'All',
        Estimator: 'All'
      }
    }
  },
  emits: ['refresh', 'datesChanged'],
  computed: {
    ...mapState(dashboardStore, ['startDate', 'endDate', 'isFetching']),
    dateStart: {
      get() {
        return this.startDate
      },
      set(value) {
        const _start = moment(value)
        const _end = moment(this.endDate)

        if (_start.isAfter(_end)) {
          // Start > End → Adjust End to match Start
          this.setDate('endDate', _start.clone().format('YYYY-MM-DD'))
        } else if (_end.diff(_start, 'days') >= this.restriction) {
          // End is too far → Adjust to Start + restriction
          this.setDate('endDate', _start.clone().add(this.restriction, 'days').format('YYYY-MM-DD'))
        }

        this.setDate('startDate', _start.format('YYYY-MM-DD'))

        this.$emit('datesChanged', {
          startDate: this.startDate,
          endDate: this.endDate,
          restriction: this.restriction
        })
      }
    },
    dateEnd: {
      get() {
        return this.endDate
      },
      set(value) {
        const _end = moment(value)
        const _start = moment(this.startDate)

        if (_end.isBefore(_start)) {
          // End is before Start, adjust startDate
          this.setDate('startDate', _end.clone().format('YYYY-MM-DD'))
        } else if (_end.clone().subtract(this.restriction, 'days').isAfter(_start)) {
          // End - restriction is after current Start, adjust Start
          this.setDate('startDate', _end.clone().subtract(this.restriction, 'days').format('YYYY-MM-DD'))
        }

        this.setDate('endDate', _end.format('YYYY-MM-DD'))
        this.$emit('datesChanged', {
          startDate: this.startDate,
          endDate: this.endDate,
          restriction: this.restriction
        })
      }
    }
  },
  methods: {
    ...mapActions(dashboardStore, ['setDate']),
    formatDate(date) {
      return moment(date).format('MM/DD/YYYY')
    },
    resetFilters() {
      console.log('Filters changed', this.filters)
      this.selected = this.selectLabels()
    },
    selectLabels() {
      let keyValue = {}
      if (this.filters) {
        this.filters.map((res) => {
          keyValue[res.selectLabel] = res.selectOptions[0].value
        })
      }
      return keyValue
    },
    reset() {
      this.$emit('filter', 'reset')
    },
    filter() {
      this.$emit('filter', this.selected)
    },
    refresh() {
      this.$emit('refresh', true)
      this.showFilters = null
    },
    showFilterDialog() {
      this.showFilters = true
      console.log(this.showFilters)
    },
    closeModal() {
      this.showFilters = null
      console.log(this.showFilters)
    }
  },
  mounted() {
    const today = new Date()
    // const year = today.getFullYear()
    const year = 2100
    const month = String(today.getMonth() + 1).padStart(2, '0')
    const day = String(today.getDate()).padStart(2, '0')
    this.maxDate = `${year}-${month}-${day}`
  }
}
</script>
<style scoped>
.custom-arrow {
  font-size: 1.2em;
  font-weight: 500;
}

.back-button {
  text-align: center;
}

.custom-select-choices {
  width: 100%;
  padding: 10px 20px 10px 10px;
  margin: 4px 8px;
  border-radius: 6px;
  border: solid 1px var(--bs-border-color);
  background-color: var(--default-light);
  color: var(--cs-primary);
}

.refreshButton {
  max-width: 190px;
  width: 100%;
}

.modal-dialog {
  position: fixed !important;
  top: auto !important;
  right: auto !important;
  left: auto !important;
  bottom: 0 !important;
}

@media (max-width: 767px) {
  .custom-select-choices {
    margin: 6px 0px;
  }
}

.custom-date {
  margin-left: 5px;
  margin-top: 8px;
}
</style>
